import React from 'react';
import './GrowthAnimation.css';

const GrowthAnimation: React.FC = () => {
  return (
    <div className="growth-animation-container">
      <svg viewBox="0 0 400 300" className="growth-svg">
        <defs>
          <linearGradient id="growthGradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#50aae3" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#50aae3" stopOpacity="0" />
          </linearGradient>
        </defs>
        
        {/* Grid lines */}
        <g className="grid-lines">
          <line x1="40" y1="260" x2="360" y2="260" />
          <line x1="40" y1="200" x2="360" y2="200" />
          <line x1="40" y1="140" x2="360" y2="140" />
          <line x1="40" y1="80" x2="360" y2="80" />
        </g>
        
        {/* Axes */}
        <line x1="40" y1="40" x2="40" y2="260" className="axis" />
        <line x1="40" y1="260" x2="380" y2="260" className="axis" />
        
        {/* Growth Area */}
        <path 
          d="M40,260 L100,220 L160,230 L220,160 L280,180 L360,60 V260 H40Z" 
          className="growth-area" 
          fill="url(#growthGradient)"
        />
        
        {/* Growth Line */}
        <path 
          d="M40,260 L100,220 L160,230 L220,160 L280,180 L360,60" 
          className="growth-line" 
        />
        
        {/* Data Points */}
        <circle cx="100" cy="220" r="4" className="data-point p1" />
        <circle cx="160" cy="230" r="4" className="data-point p2" />
        <circle cx="220" cy="160" r="4" className="data-point p3" />
        <circle cx="280" cy="180" r="4" className="data-point p4" />
        <circle cx="360" cy="60" r="6" className="data-point p5" />
        
        {/* Floating Elements (Coins/Bubbles) */}
        <circle cx="300" cy="100" r="15" className="floating-bubble b1" />
        <circle cx="180" cy="80" r="10" className="floating-bubble b2" />
        <circle cx="250" cy="50" r="8" className="floating-bubble b3" />
      </svg>
    </div>
  );
};

export default GrowthAnimation;
